import { useTranslation } from "react-i18next"
import Grid from "@mui/material/Grid"

import TitleWithAvatar from "widgets/common/TitleWithAvatar"
import CreateGroupButton from "widgets/deviceGroups/editor/CreateGroupButton"
import { HeaderContainer } from "widgets/styled/containers"
import usePermissions from "helpers/hooks/usePermissions"
import GroupCardsSection from "widgets/deviceGroups/GroupCardsSection"

const GroupsSection = () => {
  const { t } = useTranslation()
  const { isEditor } = usePermissions()

  return (
    <Grid item xs={12}>
      <HeaderContainer>
        <TitleWithAvatar entity="group" title={t("device_groups.DEVICE_GROUPS")} />
        {isEditor && <CreateGroupButton />}
      </HeaderContainer>
      <GroupCardsSection />
    </Grid>
  )
}

export default GroupsSection
